/* eslint-disable */
<template>
  <!-- eslint-disable -->
  <CategoryDefinitionForm title='category' collection='terms'></CategoryDefinitionForm>
</template>
<script>
/* eslint-disable */
import CategoryDefinitionForm from './CategoryDefinitionForm'

export default {
  name: 'EditCategoryDefinition',
  components: {
    CategoryDefinitionForm
  }
}
</script>
